<template>
    <el-container>
        <el-aside :class="[isSideShow?(isActive?'sidebar':'hiddenSidebar'):'HIDDEN']" style="transition: width .28s;">
            <sidebar :isCollapse="!isActive" />
        </el-aside>
        <el-container>
            <el-header :class="[isHeadShow?'headbar':'HIDDEN']">
                <i :class="[!isActive?'el-icon-s-unfold':'el-icon-s-fold','hambeger']" @click="isActive=!isActive"></i>
                <div class="right-menu">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            <i class="el-icon-s-custom" style="padding-right:10px;"></i>{{userName}}<i class="el-icon-arrow-down" style="padding-left:5px;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="exit"><i class="el-icon-circle-close"></i>退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>
            <el-main>
                <tabs></tabs>
            </el-main>
            <el-footer class="footbar">Copyright © 2025 华夏安健物联科技（青岛）有限公司 Version 3.0</el-footer>
        </el-container>
    </el-container>
</template>

<script>
    import { loginOut } from '@/api/utils'
    import Sidebar from '@/components/Sidebar'
    import Tabs from '@/components/Tabs'

    export default {
        name: 'Layout',
        components: {
            Sidebar,
            Tabs
        },
        data() {
            return {
                isActive: true
            }
        },
        computed: {
            userName() {
                return this.$store.getters.name;
            },
            isSideShow() {
                return this.$store.getters.isSideShow;
            },
            isHeadShow() {
                return this.$store.getters.isHeadShow;
            },
            getcurrentYear() {
                var dd = new Date();
                return dd.getFullYear();
            }
        },
        created() {
            this.$store.commit('app/CLEAR_TABS');
            let mainpage = this.$store.getters.menu.find(item => item.component === 'mainPage');
            if (mainpage !== undefined) this.$store.commit('app/ADD_TAB', mainpage);

        },
        mounted() {
            document.title = "华夏安健水质溯源系统";
        },
        methods: {
            handleCommand(command) {
                switch (command) {
                    case 'exit':
                        var that = this;
                        this.$XModal.confirm('确认退出当前 '+this.userName+' 用户?').then(type => {
                            if (type === 'confirm') {
                                loginOut().then((_resData) => {
                                    if (_resData.Code == 1) {
                                        that.$message({
                                            message: _resData.Msg,
                                            type: 'success'
                                        });
                                        that.$store.commit('user/REMOVE_LOGININFO');
                                        that.$router.push({ name: "login" }).catch(() => { });
                                    } else {
                                        that.$message.error(_resData.Msg);
                                    }
                                });
                            }
                        });
                        break;
                    default:
                }
            },
        }
    };
</script>

<style scoped>

</style>
